import script from "./StatsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./StatsComponent.vue?vue&type=script&setup=true&lang=js"

import "./StatsComponent.vue?vue&type=style&index=0&id=3da54a54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3da54a54"]])

export default __exports__